import { render } from "./TransactionsManagement.vue?vue&type=template&id=6852659e&scoped=true"
import script from "./TransactionsManagement.vue?vue&type=script&lang=js"
export * from "./TransactionsManagement.vue?vue&type=script&lang=js"

import "./TransactionsManagement.vue?vue&type=style&index=0&id=6852659e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6852659e"]])

export default __exports__